import AddCustomer from "./AddCustomer";
import './addCustomer.scss'

export default AddCustomer;